import { Routes } from '@angular/router';
import { EditContactComponent } from './pages/edit-contact/edit-contact.component';
import { InteractionsContactComponent } from './pages/interactions-contact/interactions-contact.component';
import { ListeContactsComponent } from './pages/liste-contacts/liste-contacts.component';

export const CONTACTS_ROUTE_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP'],
    menu: {
        libelle: 'menu.administration-contacts',
        icon: 'key'
    }
};

export const CONTACTS_ROUTES: Routes = [
    { path: '', component: ListeContactsComponent },
    { path: 'new', component: EditContactComponent, data: { roles: ['ORGANISME'] } },
    { path: ':id/interactions', component: InteractionsContactComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:idc', component: EditContactComponent, data: { roles: ['ORGANISME'] } }
];
